import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrders,
  fetchMediaData,
  setCurrentPage,
  pagesCount,
} from "../../features/orders/ordersSlice";
import { useNavigate } from "react-router-dom";
import coins from "../../image/coins.gif";

const LoyaltyProgram = () => {
  const dispatch = useDispatch();
  const { orders, status, mediaData, error, tabChange } = useSelector(
    (state) => state.orders
  );

  const { totalPages, currentPage } = useSelector((state) => state.orders);

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  useEffect(() => {
    if (tabChange === "loyalty-program") {
      dispatch(fetchOrders(page)).then((result) => {
        dispatch(fetchMediaData(result.payload));
      });
    } else {
      setPage(1);
      dispatch(setCurrentPage(1));
      dispatch(pagesCount(0));
    }
  }, [dispatch, page, tabChange]);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  const renderOrderItem = (order) => {
    const statusColor =
      order.status.toLowerCase() === "cancelled" ? "red" : "green";
    const createdAtDate = new Date(order.createdAt).toLocaleDateString();

    return (
      <div key={order._id} className="items-in-cart Delivered-box">
        <div
          className="div-txt-with-item-fr"
          onClick={() => navigate(`/ordertracking`)}
        >
          <h5 className="head-add-item-fr">Order ID: {order._id}</h5>
          <div className="wallet-coins">
            <img
              src={coins}
              alt="coins"
              style={{ width: "15px", height: "15px" }}
            />
            <span className="mx-2">
              Loyalty Coins Redeem: {Number(order.loyality_coins)?.toFixed(2)}
            </span>
          </div>
          {/* Display the order creation date */}
          <h5 className="head-add-item-fr">Order Date: {createdAtDate}</h5>
          {/* <p>Order Date: {createdAtDate}</p> */}
        </div>

        {order.products && order.products.length > 0 ? (
          order.products.map((product) => (
            <div key={product.media_id} className="cart-item">
              {mediaData[product.media_id] ? (
                <img
                  src={mediaData[product.media_id].url}
                  alt={product.product.title}
                />
              ) : (
                <p>Loading image...</p>
              )}
              <div className="item-details">
                <div className="item-header">
                  <h3>{product.product.title}</h3>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No products found in this order.</p>
        )}
      </div>
    );
  };
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <div className="container">
      <div className="main-div my-oders-2">
        <h1>Loyalty Program History</h1>
        {orders && orders.length > 0 ? (
          orders.map((order) => renderOrderItem(order))
        ) : (
          <div className="empty-box">
            <div className="items-in-cart text-center border-0">
              <h6>No Orders Found!</h6>
              <button className="btn btnOpenForm1">Order Now</button>
            </div>
          </div>
        )}
        <div className="col-auto">
          <nav aria-label="Page navigation">
            <ul className="pagination justify-content-end mb-0">
              {/* Previous Button */}
              <li className={`page-item ${currentPage <= 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage <= 1}
                >
                  Previous
                </button>
              </li>

              {/* Show limited page numbers */}
              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter(
                  (page) =>
                    page === 1 ||
                    page === totalPages ||
                    (page >= currentPage - 2 && page <= currentPage + 2)
                )
                .map((page, index, arr) => (
                  <React.Fragment key={page}>
                    {index > 0 && arr[index - 1] !== page - 1 && (
                      <li className="page-item disabled">
                        <span className="page-link">...</span>
                      </li>
                    )}
                    <li
                      className={`page-item ${
                        currentPage === page ? "active" : ""
                      }`}
                    >
                      {/* .toFixed(2) */}
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    </li>
                  </React.Fragment>
                ))}

              {/* Next Button */}
              <li
                className={`page-item ${
                  currentPage >= totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage >= totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyProgram;
